import * as action_types from "./constants";
import { takeOffTableType } from "./types";

export type myTeamState = {
  takeOffData: {
    loader: boolean;
    data: takeOffTableType[] | null;
  };
  unitFormData: { label: string; value: string }[];
};

const initialState: myTeamState = {
  takeOffData: {
    loader: true,
    data: null,
  },
  unitFormData: [],
};

type MyUnitActionType =
  | {
      type: typeof action_types.UNIT_FORM_DATA;
      data: { label: string; value: string }[];
    }
  | {
      type: typeof action_types.TAKE_OFF_LISTING;
      data: { payload: takeOffTableType[]; loading: boolean };
    };

const myTeamReducer = (
  state = initialState,
  action: MyUnitActionType
): myTeamState => {
  const { type, data } = action;
  switch (type) {
    case action_types.TAKE_OFF_LISTING:
      return {
        ...state,
        takeOffData: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.UNIT_FORM_DATA:
      return {
        ...state,
        unitFormData: data,
      };

    default:
      return state;
  }
};

export default myTeamReducer;
